import {
  loadingFailAction,
  loadingStartAction,
  loadingSuccessAction,
} from "@wisr/common";
import Axios, { AxiosResponse } from "axios";
import { Epic } from "redux-observable";
import { concat, from, Observable, of } from "rxjs";
import { catchError, concatMap, map, tap } from "rxjs/operators";

import { redirect } from "../shared/browser.utils";
import { DASH_API } from "../shared/url.constants";
import { PartnerReferral } from "./partner-referral";
import {
  PartnerReferralGetAction,
  PartnerReferralGetActionType,
  partnerReferralGetSuccessAction,
} from "./partner-referral.actions";

export const GET_PARTNER_REFERRAL_LOADING = "GET_PARTNER_REFERRAL_LOADING";
export const getPartnerReferralEpic: Epic = (actions) =>
  actions.ofType<PartnerReferralGetAction>(PartnerReferralGetActionType).pipe(
    concatMap((action) =>
      concat(
        of(loadingStartAction(GET_PARTNER_REFERRAL_LOADING)),
        getPartnerReferral(action.wisrCustomerId).pipe(
          tap((partnerReferral: PartnerReferral) => {
            if (partnerReferral.partnerUrl) {
              redirect(partnerReferral.partnerUrl);
            }
          }),
          concatMap((partnerReferral) => [
            partnerReferralGetSuccessAction(partnerReferral),
            loadingSuccessAction(GET_PARTNER_REFERRAL_LOADING),
          ])
        )
      )
    ),
    catchError(() =>
      of(loadingFailAction(GET_PARTNER_REFERRAL_LOADING, "Unexpected Error"))
    )
  );

function getPartnerReferral(
  wisrCustomerId: string
): Observable<PartnerReferral> {
  return from(
    Axios.post<PartnerReferral>(`${DASH_API}/api/v1/partnerreferral`, {
      wisrCustomerId,
      application: "rate-estimate",
    })
  ).pipe(map((res: AxiosResponse) => res.data));
}
